@if (stepForm) {
  <form
    id="step-form"
    [formGroup]="stepForm">
    @if (catalogEntryQuestions?.length > 0) {
      <div class="request-container-4 request-content4-scrollable aa-scrollable-y aa-scrollbar"
        >
        <div class="request-content">
          @for (question of catalogEntryQuestions; track question) {
            <div class="question"
              >
              @if (question.hasEndpoint) {
                @switch (question.endpointGuid) {
                  @case (its2EndpointGuid.Server) {
                    <aa-input-servers
                      [required]="question.required ? 'required' : undefined"
                      label="{{ question.label[currentLang] }}"
                      [name]="question.name"
                      [formControlName]="question.name">
                    </aa-input-servers>
                  }
                  @case (its2EndpointGuid.Policy) {
                    <aa-input-policies
                      [required]="question.required ? 'required' : undefined"
                      label="{{ question.label[currentLang] }}"
                      [name]="question.name"
                      [formControlName]="question.name">
                    </aa-input-policies>
                  }
                }
              }
              @if (!question.hasEndpoint) {
                @switch (question.type) {
                  @case ('list') {
                    <aa-input-its2-list
                      [question]="question"
                      [required]="question.required ? 'required' : undefined"
                      label="{{ question.label[currentLang] }}"
                      [name]="question.name"
                      [formControlName]="question.name">
                    </aa-input-its2-list>
                  }
                  @case ('editor') {
                    <aa-input-editor
                      [required]="question.required ? 'required' : undefined"
                      label="{{ question.label[currentLang] }}"
                      [name]="question.name"
                      [formControlName]="question.name">
                    </aa-input-editor>
                  }
                  @case ('text') {
                    <aa-input-text2
                      [required]="question.required ? 'required' : undefined"
                      label="{{ question.label[currentLang] }}"
                      [name]="question.name"
                      [formControlName]="question.name">
                    </aa-input-text2>
                  }
                  @case ('email') {
                    <aa-input-email2
                      [required]="question.required ? 'required' : undefined"
                      name="{{ question.name }}"
                      label="{{ question.label[currentLang] }}"
                      formControlName="{{ question.name }}">
                    </aa-input-email2>
                  }
                  @case ('password') {
                    <aa-input-password2
                      [required]="question.required ? 'required' : undefined"
                      name="{{ question.name }}"
                      label="{{ question.label[currentLang] }}"
                      formControlName="{{ question.name }}">
                    </aa-input-password2>
                  }
                  @case ('number') {
                    <aa-input-number2
                      [required]="question.required ? 'required' : undefined"
                      name="{{ question.name }}"
                      label="{{ question.label[currentLang] }}"
                      formControlName="{{ question.name }}">
                    </aa-input-number2>
                  }
                  @case ('date') {
                    <aa-input-date2
                      [required]="question.required ? 'required' : undefined"
                      name="{{ question.name }}"
                      label="{{ question.label[currentLang] }}"
                      formControlName="{{ question.name }}">
                    </aa-input-date2>
                  }
                  @case ('radio') {
                    <aa-radio-group3
                      [required]="question.required ? 'required' : undefined"
                      name="{{ question.name }}"
                      label="{{ question.label[currentLang] }}"
                      formControlName="{{ question.name }}"
                      [orientation]="'horizontal'"
                      [options]="question.options"
                      [marginTop]="0">
                    </aa-radio-group3>
                  }
                  @case ('comment') {
                    <span [innerHtml]="question.label[currentLang]"></span>
                  }
                }
              }
            </div>
          }
        </div>
      </div>
    }
  </form>
}
